export const sEmptyGuid = '00000000-0000-0000-0000-000000000000';

export const sEmptyLookupId = '0-00000000';
